// eslint-disable-next-line import/extensions
import logoImage from './assets/logo.png';

export default {
  name: 'TheMainLogo',

  props: {
    image: {
      type: String,
      default: logoImage,
    },
    className: {
      type: String,
    },
  },

  data() {
    return {
      logo: logoImage,
    };
  },
};
